import React from 'react';

import { listEmployees } from '../../../generated/graphql/queries';
import { UserGrid, StatusPill } from '../../../components';
import { EmployeeType, UserTypes } from '../../../constants';

const statusOptions = [
  { value: EmployeeType.Admin, label: 'Admin' },
  { value: EmployeeType.Staff, label: 'Staff' },
];

const StaffUsers = () => {
  const renderStaffType = ({ userStatus }) => <StatusPill status={userStatus} />;

  const statusColumn = { title: 'Type', fieldName: 'userStatus', renderFunction: renderStaffType, sortable: true };

  return (
    <UserGrid
      query={listEmployees}
      queryName="listEmployees"
      statusOptions={statusOptions}
      title="Staff Users"
      statusColumn={statusColumn}
      statusFilterLabel="Type"
      createUserDefaultType={UserTypes.Staff}
      showDisabledAt
    />
  );
};

export default StaffUsers;
